var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPurpleGift = function SvgPurpleGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC61DF",
    stroke: "url(#purple-gift_svg__a)",
    strokeWidth: 0.2,
    d: "M11.239 14.137h-.1.1v-.008l-.001-.015a.5.5 0 0 0-.057-.206.4.4 0 0 0-.148-.164.5.5 0 0 0-.273-.073H3.291v.1-.1a1.18 1.18 0 0 0-1.176 1.176v8.077A1.18 1.18 0 0 0 3.29 24.1V24v.1h7.594q.124-.002.206-.062a.34.34 0 0 0 .107-.132.5.5 0 0 0 .04-.16v-.012l.001-.004v-.002h-.1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC61DF",
    stroke: "url(#purple-gift_svg__b)",
    strokeWidth: 0.2,
    d: "M20.805 24v.1a1.18 1.18 0 0 0 1.176-1.177v-8.076a1.18 1.18 0 0 0-1.176-1.176v.1-.1h-7.461a.5.5 0 0 0-.314.095.44.44 0 0 0-.145.21.65.65 0 0 0-.028.274v9.504a.4.4 0 0 0 .043.16.33.33 0 0 0 .115.128.4.4 0 0 0 .211.057h7.578z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC61DF",
    stroke: "url(#purple-gift_svg__c)",
    strokeWidth: 0.2,
    d: "M11.14 7.417h.1v-.008l-.002-.015a.6.6 0 0 0-.054-.204.42.42 0 0 0-.405-.238H2.077v.1-.1A1.18 1.18 0 0 0 .9 8.128v3.36a1.18 1.18 0 0 0 1.176 1.175v-.1.1h8.732c.202 0 .317-.09.377-.193a.4.4 0 0 0 .054-.187v-.006h-.1.1v-4.86z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC61DF",
    stroke: "url(#purple-gift_svg__d)",
    strokeWidth: 0.2,
    d: "M22.02 12.563v.1a1.18 1.18 0 0 0 1.176-1.176V8.128a1.18 1.18 0 0 0-1.176-1.176v.1-.1h-8.73a.45.45 0 0 0-.246.065.4.4 0 0 0-.134.147.5.5 0 0 0-.053.198v.006l.1.001h-.1v4.914h.098-.098v.008l.01.06a.4.4 0 0 0 .06.13c.072.101.206.182.434.182h8.659z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC61DF",
    stroke: "url(#purple-gift_svg__e)",
    strokeWidth: 0.2,
    d: "M3.955 5.033c-.39-.553-.505-1.231-.354-2.007.132-.677.428-1.211.872-1.575S5.5.9 6.193.9q.443 0 .953.1m-3.19 4.033L7.145 1m-3.19 4.033c.434.616 1.15 1.006 2.166 1.205.402.078.859.118 1.356.118.836 0 1.732-.113 2.46-.311l-.027-.097.027.097c1.071-.292 1.699-.747 1.831-1.423.045-.23.043-.532-.187-.917-.226-.379-.671-.835-1.499-1.39C9.107 1.663 8.01 1.17 7.146 1m-3.19 4.033 3.17-3.935.02-.098M5.49 3.395c.048-.247.112-.38.207-.456s.24-.114.496-.114q.251 0 .584.064c.903.176 1.99.806 2.629 1.307a7.8 7.8 0 0 1-1.928.235 5.3 5.3 0 0 1-.986-.082 3 3 0 0 1-.635-.19c-.166-.075-.274-.157-.329-.235v-.002a.3.3 0 0 1-.054-.126 1 1 0 0 1 .016-.4Zm4 .777Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC61DF",
    stroke: "url(#purple-gift_svg__f)",
    strokeWidth: 0.2,
    d: "M12.35 4.622c-.044-.23-.042-.532.187-.917.227-.379.672-.835 1.5-1.39.975-.653 2.072-1.146 2.937-1.315.339-.066.659-.1.952-.1.694 0 1.277.187 1.72.55.445.365.74.899.873 1.576zm0 0c.133.676.76 1.131 1.832 1.423zm4.292-.191c-.77 0-1.454-.11-1.928-.235.636-.502 1.72-1.13 2.629-1.307q.331-.064.583-.064c.257 0 .402.037.497.114.094.076.158.209.207.456.038.197.032.323.015.4-.015.074-.04.11-.053.127v.002c-.056.078-.163.16-.33.235q-.249.114-.634.19a5.3 5.3 0 0 1-.986.082Zm1.284-1.706q-.263 0-.602.066l-2.74 1.473c.484.139 1.22.267 2.058.267.376 0 .724-.03 1.005-.084.522-.102.886-.267 1.026-.466.034-.047.136-.191.055-.605-.099-.505-.279-.651-.802-.651Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "purple-gift_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.72672 2.0452 -5.99439 -7.9919 6.677 18.373)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "purple-gift_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.72777 2.04517 -5.99362 -7.99407 17.417 18.373)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "purple-gift_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.09797 1.10192 -2.12444 -5.9727 6.07 9.532)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "purple-gift_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(160.42 8.19 6.321)scale(3.28809 6.33928)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "purple-gift_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(156.878 3.488 2.466)scale(2.67618 5.90136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "purple-gift_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.4612 1.05086 -2.31728 -5.42727 16.455 3.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })))));
};
export default SvgPurpleGift;